module.exports = __webpack_public_path__ + "static/media/umrah-package-5.ced5708b.jpg";